// TODO: See which of these keys are still needed (do after updating UnrequiredLinks)
export const navigation = {
  about: "About",
  accountHeading: "Account",
  adminDashboard: "Admin Dashboard",
  careers: "Careers",
  careTeam: "Care team",
  chatGuidelinesDoc: "Our chat guidelines",
  clinics: "For clinics",
  coach: "Become a coach",
  createAccount: "Join",
  crew: "Crew",
  askJennySis: "Ask Jenny",
  home: "Home",
  howItWorks: "How it works",
  join: "Join",
  library: "Library",
  gatherings: "Events",
  message: {
    conceive: "Message Conceive",
    crew: "Message your Crew",
    whatsApp: "WhatsApp",
    sms: "Text (833) 909-1240",
  },
  myCareTeam: "My care team",
  philosophy: "Philosophy",
  pricing: "Pricing",
  program: "Program",
  provider: "Become a provider",
  referAFriend: "Refer-a-Friend",
  perks: "Member Perks",
  settings: "Settings",
  stopImpersonation: "Stop Impersonation",
  signIn: "Sign in",
  signOut: "Sign out",
  speakWithACoach: {
    plus: {
      heading: "Book a one-to-one with a coach",
      link: "Browse packages",
      subheading: "(Browse packages)",
    },
    premium: {
      heading: "Book a one-to-one with a coach",
      link: "Schedule here",
      subheading: "",
    },
  },
  speakWithANurse: {
    plus: {
      heading: "Book a care team one-to-one",
      link: "Browse packages",
      subheading: "(Browse packages)",
    },
    premium: {
      heading: "Book a one-to-one with a nurse",
      link: "Schedule here",
      subheading: "",
    },
  },
  upgradeToPremium: "Upgrade to Premium",
};
